import {
  ConeGeometry,
  CylinderGeometry,
  Group,
  Mesh,
  MeshStandardMaterial,
  SphereGeometry
} from 'three';

/** Ezreal mesh — gauntlet + gold trim. */
export function createEzrealMesh(team = 'blue') {
  const group = new Group();
  const trim = team === 'blue' ? 0x38bdf8 : 0xfbbf24;
  const bodyMat = new MeshStandardMaterial({ color: 0x1d4ed8, roughness: 0.45 });
  const trimMat = new MeshStandardMaterial({ color: trim, roughness: 0.3, metalness: 0.4 });
  const body = new Mesh(new ConeGeometry(0.55, 2.0, 10), bodyMat);
  body.position.y = 1.2;
  group.add(body);
  const head = new Mesh(new SphereGeometry(0.38, 12, 12), trimMat);
  head.position.y = 2.45;
  group.add(head);
  const gauntlet = new Mesh(new CylinderGeometry(0.18, 0.22, 0.7, 8), trimMat);
  gauntlet.position.set(0.7, 1.4, 0.15);
  group.add(gauntlet);
  return group;
}
